export default "__VITE_ASSET__CLyp6VyC__"